import React from 'react';
import { Modal, SparkModalPortal, Text } from '@spark';
import { optimizeOnLabelMissingCopy } from '@/shared/domain/labelPriority';
import './OptimizeOnLabelMissingModal.css';

/**
 * Blocking warning shown when the label a flow is about to optimize on is
 * not one of the task's labels: Data Collection "Next" (the Business Goals
 * "What matters most" choice vs. the labels edited on that step) and the
 * Train step's "Let's Train" (its own "Optimize on" pick). Same dialog as
 * the Data Collection benchmark warning (600px, warning icon, secondary
 * body text) but with a single "Got it" button: the user has to
 * fix the choice or the labels, there is no "continue anyway".
 *
 * `mismatch` is `{ label, taskLabels }` or null (closed).
 */
const OptimizeOnLabelMissingModal = ({ mismatch, surface, onClose }) => {
    if (!mismatch) return null;
    const { title, body } = optimizeOnLabelMissingCopy({
        label: mismatch.label,
        taskLabels: mismatch.taskLabels,
        surface,
    });
    return (
        <SparkModalPortal open onClose={onClose} size="text" className="optimize-on-missing-modal-portal">
            <Modal
                title={title}
                feedbackType="warning"
                showSubtitle={false}
                showScrollBar={false}
                showOverlay={false}
                fixedHeight={false}
                showFooter
                showTertiaryButton={false}
                primaryLabel="Got it"
                onPrimaryClick={onClose}
                onCloseClick={onClose}
                className="optimize-on-missing-modal"
            >
                <Text variant="base-regular" color="secondary" as="p" className="fs-unmask">
                    {body}
                </Text>
            </Modal>
        </SparkModalPortal>
    );
};

export default OptimizeOnLabelMissingModal;
